<template>
    <b-container fluid style="padding-bottom:135px;" class="bg_atos">
       <b-row class="justify-content-md-center text-center">
            <b-col md="auto">
                <b-row>
                    <b-col><img src="@/assets/../assets/new-logo-ATOS-g .png" alt="ATOS logo" class="logo-atos" style="width: 31em"/></b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col md="auto" align-h="center">
                        <div class="text-destaque">MONITORAMENTO E TRANSPARÊNCIA</div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="auto">
                <b-row>
                    <b-col class="text-destaque2">{{$t('text_home1')}}</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <router-link to="/listActs">
                            <button class="btn_atos-submit-b" style="width:200px">
                                {{$t('btn_access')}}
                            </button>
                        </router-link>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-destaque3">{{$t('text_home2')}}<span @click="showDialogSignUpMethod()">{{$t('signup')}}</span>{{$t('text_home21')}}</b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center  text-center" style="margin-top:80px" id="about">
            <b-col md="auto">
                <b-row class="justify-content-md-center">
                    <b-col md="auto" ><p class="tit_section">{{$t('tit_section1')}}</p></b-col>
                </b-row>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" sm="12" md="9" lg="8"><p class="text_section">{{$t('text_section1')}}</p></b-col>
                </b-row>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" sm="12" md="9" lg="8"><p class="text_section">{{$t('text_section11')}}</p></b-col>
                </b-row>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" sm="12" md="9" lg="8"><p class="subTit_section">{{$t('subtit_section2')}}</p></b-col>
                </b-row>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" sm="12" md="9" lg="8"><p class="text_section">{{$t('text_section2')}}</p></b-col>
                </b-row>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" sm="12" md="9" lg="8"><p class="text_section">{{$t('text_section21')}}</p></b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center  text-center" style="margin-top:40px">
            <b-col cols="4" lg="2">
                <img src="@/assets/img_dest1.png" style="width: 75px; height:75px;"/>
                <p class="tit_section2">Pesquise</p>          
            </b-col>
            <b-col cols="4" lg="2">
                <img src="@/assets/img_dest2.png" style="width: 75px; height:75px;"/>
                <p class="tit_section2">Compare</p>
            </b-col>
            <b-col cols="4" lg="2" >
                <img src="@/assets/img_dest3.png" style="width: 75px; height:75px;"/>
                <p class="tit_section2">Monitore</p>
            </b-col>
        </b-row>

        <b-row align-v="center" align-h="center">
            <b-col cols="12" sm="12" md="6" lg="8" style="text-align:center">
                <button class="btn_atos-submit-w">
                    <router-link :to="{ name: 'listActs'}" class="text_btn2">
                        {{$t('btn_access2')}}
                    </router-link>
                </button>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center  text-center" align-v="center" align-h="center">
            <b-col  cols="12" sm="12" md="9" lg="8" style="text-align:center" class="text_section"><p style="text-align:center">{{$t('text_section3')}}</p></b-col>
        </b-row>

        <b-row id="whoweare">
            <b-col class="bg_home_whoweare">
                <p class="tit_section4">{{$t('tit_section4')}}</p>
                <p class="text_section4">{{$t('text_section4')}}</p>
            </b-col>
        </b-row>

        <md-dialog hide-overlay :md-active.sync="showDialogSignUp" :md-click-outside-to-close="false">
            <signup class="wrapper-dialog" v-on:showDialogSignUp="closeDialogSignUp()"></signup>
        </md-dialog>
    </b-container>
</template>

<script>
import signup from '@/components/SignUp.vue'

export default {
    components: { 
        signup     
    },
    data() {
        return {
            showDialogSignUp : false,
            styleHome : {
                backgroundColor:"#16a085",
                height: "100vh"
            },
            
        };
    },
    methods:{
        showDialogSignUpMethod(){
            this.$store.commit('setFocusClass', 'focusClass')
            this.showDialogSignUp = true;
        },

        closeDialogSignUp(){
            this.$store.commit('setFocusClass', '')
            this.showDialogSignUp = false
        }
    }
    
}
</script>

<style scoped lang="scss">

    $break-small: 420px;
    $break-large: 1200px;

   
    .text-destaque{
        font-size: 30px;
        font-weight: 300;
        line-height: 35px;
        margin-top:15px;
        max-width: 300px;
        @media screen and (max-width: $break-small) {
            width: auto;
            max-width: initial;
            margin-bottom: 55px;
        }
    }
    .text-destaque2{
        font-size: 35px;
        font-weight: 300;
        width: 300px;
        line-height: 35px;
        margin-bottom: 35px;
    }
    .text-destaque3{
        margin-top: 35px;
        font-size: 20px;
        font-weight: 300;
        width: 300px;
        line-height: 20px;

        span{
            color:#735382;
            text-decoration: underline;
            &:hover{
                cursor: pointer;
                color:#b482cc;
            }
        }
    }
   
    @mixin styleSectionTit {
        font-family: Roboto;
        font-style: normal;
        line-height: 42px;
        text-align: center;
        color: #1937A0;
    }
    .tit_section{
        @include styleSectionTit;
        font-weight: 300;
        font-size: 36px;
        max-width:850px
    }

    .subTit_section{
        @include styleSectionTit;
        
        font-weight: 300;
        font-size: 36px;
        margin-top: 20px;
    }

    .text_section{
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #000000;
    }

    .tit_section2{
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 24px;
        line-height: 28px;
        color: #1937A0;
        padding-top: 20px;
    }
    
 
    .cointainer-home{
        
        display: inline-flex;
        position: relative;
    
        .grid_home2{
            display: grid;
            grid-template-rows: 1fr 1fr;
            justify-items: center;    
            align-items: center;  
            text-align: center;

            font-family: 'roboto';
            

         

            

            .dialog_theme{
                max-width: 400px;
                height: auto;
                background-color: #000 !important;
            }  
        }
    }

    .bg_home_whoweare{
        justify-content: center;
        background: #1937A0;
        display: grid;
        padding-top: 85px;
        
        margin-top: 85px;
        padding-bottom:80px;

        .tit_section4{
            font-family: Roboto;
            font-style: normal;
            font-weight: 300;
            font-size: 36px;
            line-height: 42px;
            text-align: center;
            
            color: rgba(255, 255, 255, 0.96);
            max-width: 870px;
        }

        .text_section4{
            font-family: Roboto;
            font-style: normal;
            font-weight: 300;
            font-size: 18px;
            line-height: 27px;
           
            text-align: center;
            color: #FFFFFF;
            max-width: 870px;
        }
    }


    .md-dialog.md-theme-default{
      background-color: initial;
      border-radius: 25px;
    }


    
</style>
